import Vue from "vue";
import VueRouter from "vue-router";
import sessionMixin from "@/mixins/sessionMixin";

Vue.use(VueRouter);

const authMiddleware = (to, from, next, context) => {
  const { isAuthenticated } = context;

  if (!isAuthenticated) {
    return next({ name: "loginStaff" });
  }
  next();
};

const guestMiddleware = (to, from, next, context) => {
  const { isAuthenticated } = context;

  if (isAuthenticated) {
    return next({ name: "operationsManager" });
  }
  next();
};

const runMiddleware = (middlewares, to, from, next) => {
  const user = sessionMixin.methods.getAuthUser();
  const isAuthenticated = sessionMixin.methods.isAuthenticated();

  const context = { user, isAuthenticated };

  const executeMiddleware = (index) => {
    if (index >= middlewares.length) {
      return next();
    }

    const middleware = middlewares[index];
    middleware(
      to,
      from,
      (nextArg) => {
        if (nextArg) {
          return next(nextArg);
        }
        executeMiddleware(index + 1);
      },
      context
    );
  };

  executeMiddleware(0);
};

const routes = [
  {
    path: "*",
    component: () => import("@/views/public/NotFound.vue"),
    meta: { layout: "full-width-layout" },
  },
  {
    path: "/",
    name: "loginStaff",
    component: () => import("@/views/public/security/LoginStaff.vue"),
    meta: { layout: "full-width-layout", middleware: [guestMiddleware] },
  },
  {
    path: "/gestionar-operaciones/:id?/:tab?",
    name: "operationsManager",
    component: () =>
      import("@/views/private/operations-manager/OperationsManager.vue"),
    meta: {
      layout: "admin-layout",
      middleware: [authMiddleware],
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const middlewares = to.meta.middleware || [];

  if (middlewares.length === 0) {
    return next();
  }

  runMiddleware(middlewares, to, from, next);
});

export default router;
